import yup from 'utils/yup';

const validationSchema = yup.object().shape({
  companyName: yup.string().required(),
  email: yup.string().email().required(),
  primaryColor: yup.string().hex().nullable(),
});

export default validationSchema;
